import React from 'react';

export const TermsConditions = () => (
  <div className="mt-2 px-3 text-center">
    <span className="text-muted">By signing up you are agreeing to Open Rewards'</span>
    <br />
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary ml-1"
      href="https://www.bludot.io/terms-and-conditions"
    >
      Terms of Service
    </a>{' '}
    and
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary ml-1"
      href="https://www.bludot.io/privacy-policy"
    >
      Privacy Policy
    </a>
  </div>
);
